/**
 * @copyright Copyright 2023-2023 Epic Systems Corporation
 * @file button for linking to an app's external website
 * @module Epic.AppOrchard.Showroom.WebsiteButton
 */

import { Button, ButtonProps, Link } from "@chakra-ui/react";
import React, { FunctionComponent, memo } from "react";
import { BiWorld } from "react-icons/bi";

interface IProps {
	appUrl: string;
	orgName: string;
	iconColor: string;
	buttonProps?: ButtonProps;
}

export const WebsiteButton: FunctionComponent<IProps> = memo((props) => {
	const { appUrl, orgName, iconColor, buttonProps } = props;

	const computedButtonProps: ButtonProps = {
		h: buttonProps?.h || buttonProps?.height || "8",
		borderRadius: buttonProps?.borderRadius || "50px",
		fontSize: buttonProps?.fontSize || "0.9rem",
		fontWeight: buttonProps?.fontWeight || "normal",
		px: buttonProps?.px || buttonProps?.paddingX || 2,
		variant: buttonProps?.variant || "card",
		as: buttonProps?.as || Link,
		iconSpacing: buttonProps?.iconSpacing || "3px",
		title: buttonProps?.title || `Navigate to ${orgName}'s external page`,
		...buttonProps,
	};

	return (
		<Button {...computedButtonProps} href={appUrl} isExternal leftIcon={<BiWorld color={iconColor} />}>
			Website
		</Button>
	);
});
